<script setup>
defineOptions({ name: "SupportSubnav" });

defineProps({
  navLinks: { type: Array, default: () => [] },
  activeNav: { type: String, default: "" },
  ctaLabel: { type: String, default: "" },
  ctaHref: { type: String, default: "" },
});

defineEmits(["nav-click"]);
</script>

<template>
  <section
    class="sticky top-16 z-40 border-b border-gray-100 shadow-sm backdrop-blur bg-white/95"
  >
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="flex gap-6 justify-between items-center h-16">
        <nav
          class="flex overflow-x-auto relative gap-6 items-center h-16"
          aria-label="Navegação da página"
        >
          <a
            v-for="item in navLinks"
            :key="item.href"
            :href="item.href"
            class="menu-item-underline relative inline-flex items-center px-2 h-16 text-sm font-bold text-gray-700 hover:text-[#006086] transition-all duration-300 whitespace-nowrap"
            :class="{ 'text-[#006086] active': activeNav === item.href }"
            @click="(e) => $emit('nav-click', e, item.href)"
          >
            {{ item.label }}
          </a>
        </nav>

        <a
          v-if="ctaLabel && ctaHref"
          :href="ctaHref"
          class="hidden sm:inline-flex items-center px-3 py-2 text-sm font-bold text-white bg-[#006086] hover:bg-[#004d6b] rounded-md shadow-sm transition-all duration-150 hover:shadow transform hover:-translate-y-0.5"
        >
          {{ ctaLabel }}
        </a>
      </div>
    </div>
  </section>
</template>
